<div class="col-md-12 mb-30" *ngIf="Selected_Record_Switcher=='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">Suggestion List</h5>
     <br/>
     <br/>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Title</label>
        <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text" class="form-control"  placeholder="Type here to search...">
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button  type="button" (click)="ReadData_Suggest()" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <button (click)="Set_Form_Suggest_View_Add()" type="button"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add New Record </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th style="cursor: pointer;" (click)="ChangeOrder('title')">
                <i *ngIf="order=='title' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='title' && orderreverse" class="fa fa-sort-up"></i>
                Title
              </th>
              <th>Status</th>
              <th style="cursor: pointer;" (click)="ChangeOrder('persianDate')">
                <i *ngIf="order=='persianDate' && !orderreverse" class="fa fa-sort-down"></i>
                <i *ngIf="order=='persianDate' && orderreverse" class="fa fa-sort-up"></i>
                Registration Date
              </th>
              <th>Registered By</th>
              <th colspan="2">Last Action</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Suggest | orderBy: order : orderreverse
            |filter:Filter_title:'title'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Suggest|filter:Filter_title:'title').length
                      }">
              <td>{{DataList_Suggest.indexOf(item)+1}}</td>
              <td>{{item.id}}</td>
              <td>{{item.title}}</td>
              <td>
                <p *ngIf="item.last_status==0 || item.last_status==4" style="color: #5f399b;">Under Review</p>
                <p *ngIf="item.last_status==3" style="color: #5f399b;">Archived</p>
                <p *ngIf="item.last_status==1" style="color: rgb(20, 220, 20);">Approved Suggestion</p>
                <p *ngIf="item.last_status==-1" style="color: rgb(220, 33, 20);">Rejected Suggestion</p>
                <p *ngIf="item.last_status==2" style="color: #5f399b;">Returned for Revision</p>
              </td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>

              <td>{{item.last_persianDate}} </td>
              <td>{{item.last_dsc}} </td>

              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a style="cursor: pointer;" class="dropdown-item" (click)="Set_Form_Suggest_View(item,'Form')"><i class="fa fa-eye"></i> View Request </a>
                    </div>
                </div>

                <div *ngIf="item.DeletingProccess" >
                  <img  src="assets/Loading.gif" style="width: 25px;" />
                </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event"></pagination-controls>
  </div>
</div>


<div  class="col-md-12 mb-30" *ngIf="Selected_Record_Switcher=='Form'">
  <app-SuggestForm
    [inner_Suggest]="Data_Seleted_Suggest">
  </app-SuggestForm>

  <button (click)="Set_List_Suggest_View()" type="button" class="btn btn-warning"><i
    class="fa fa-mail-reply"></i> Back </button>

</div>
